// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-item {
  border: 2px solid rgb(225, 234, 245);
  border-radius: 25px;
  padding: 5px 10px;
}

.fileName {
  word-break: break-all;
}

.p-progressbar.red .p-progressbar-value {
  background-color: red;
}

@media (max-width: 768px) {
  .upload-files .file-item {
    flex-wrap: wrap;
    row-gap: 0.25rem;
  }

  .upload-files .file-item--uploaded {
    flex: 1 1 auto;
    min-width: 0;
  }

  .upload-files .file-item .fileName {
    min-width: 0;
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: normal;
  }

  .upload-files .file-item > .p-button {
    flex-shrink: 0;
  }

  .upload-files .file-item .modifiedByUser {
    margin-left: 0 !important;
    width: 100%;
    order: 3;
    font-size: 0.75rem;
  }

  .upload-files .task-attachments-section
    > .flex.justify-content-between.align-items-center {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/FileUpload.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,QAAQ;IACR,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".file-item {\n  border: 2px solid rgb(225, 234, 245);\n  border-radius: 25px;\n  padding: 5px 10px;\n}\n\n.fileName {\n  word-break: break-all;\n}\n\n.p-progressbar.red .p-progressbar-value {\n  background-color: red;\n}\n\n@media (max-width: 768px) {\n  .upload-files .file-item {\n    flex-wrap: wrap;\n    row-gap: 0.25rem;\n  }\n\n  .upload-files .file-item--uploaded {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .upload-files .file-item .fileName {\n    min-width: 0;\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: normal;\n  }\n\n  .upload-files .file-item > .p-button {\n    flex-shrink: 0;\n  }\n\n  .upload-files .file-item .modifiedByUser {\n    margin-left: 0 !important;\n    width: 100%;\n    order: 3;\n    font-size: 0.75rem;\n  }\n\n  .upload-files .task-attachments-section\n    > .flex.justify-content-between.align-items-center {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
